import React from 'react'

interface Props {
    size?: number
    color?: string
}

export const ImagePlaceholder: React.FC<Props> = ({ size = 100, color = 'currentcolor' }) => {
    return (
        <svg width={size} height={size} viewBox='0 0 112 71' fill='none'>
            <path
                d='M86.0016 26.6589C78.7193 17.7496 65.4254 17.7496 58.1431 26.6589L46.176 41.2998C41.9747 46.4397 34.3052 46.4397 30.104 41.2998C25.9027 36.1599 18.2333 36.1599 14.032 41.2998L2.57901 55.3116C-2.42258 61.4306 1.78946 70.7941 9.54361 70.7941L102.457 70.7941C110.211 70.7941 114.423 61.4306 109.422 55.3116L86.0016 26.6589Z'
                fill={color}
            />
            <path
                d='M49.1649 14.3235C49.1649 22.1205 43.0441 28.4412 35.4939 28.4412C27.9436 28.4412 21.8229 22.1205 21.8229 14.3235C21.8229 6.52656 27.9436 0.205874 35.4939 0.205875C43.0441 0.205875 49.1649 6.52656 49.1649 14.3235Z'
                fill={color}
            />
        </svg>
    )
}
